module.exports = __webpack_public_path__ + "img/cart_all.85790dc1.svg";